import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './ThingsPage.css';
import { useNavigate } from 'react-router-dom';
import { useAudio } from './AudioContext';
import t1 from './images/t1.webp';
import t2 from './images/t2.webp';
import t3 from './images/t3.webp';
import t4 from './images/t4.webp';
import t5 from './images/t5.webp';
import t6 from './images/t6.webp';
import t7 from './images/t7.webp';
import t8 from './images/t8.webp';
import t9 from './images/t9.webp';
import thingsText from './images/things_text.webp';

const sweet = withReactContent(Swal);
const LETTERS = ['A', 'B', 'C', 'D', 'F', 'G', 'H', 'I', 'J'];
const DESC = [
  'perhatian bahkan sampe hal hal kecik yang kadang dak revi notice',
  'support and care of me anytime',
  'humble and kind with others, revi seneng liat sayang banyak kawan',
  'family is everything untuk sayang, revi bangga',
  'kalo lagi ketawo lucu nian!',
  'good listener, tapi cuma boleh samo revi bae yo sayang kalo ke cewek😠',
  'ambitious and hardworking to be the best in everything, revi bakal selalu support!',
  'kalo lagi protective possesive, revi ngeraso makin disayang nian',
  'everything about you, litterly everything and anything, thats why i love you🫶🏻',
];
const PICTURES = [t1, t2, t3, t4, t5, t6, t7, t8, t9];

export default function ThingsPage() {
  const [showTitle, setShowTitle] = useState(false);
  const [planePosition, setPlanePosition] = useState({ top: 0, left: '50%', visible: false, rotation: 0, index: -1 });
  const [showNext, setShowNext] = useState(false);
  const containerRefs = useRef([]);
  const scrollContainerRef = useRef(null);
  const navigate = useNavigate();
  const { playSound1 } = useAudio();

  useEffect(() => {
    // Continue playing sound1 (will continue if already playing, or start if not)
    playSound1();
  }, [playSound1]);

  useEffect(() => {
    sweet.fire({
      title: <h2>halooo😋</h2>,
      html: <div style={{fontSize:'1.05em'}}>
        before you start scrolling this site,<br/>
        <strong>happy birthday btw sayangku cintaku!</strong><br/>
        hope you like it and love you sayang
      </div>,
      showConfirmButton: true,
      confirmButtonText: 'Love you more 💜',
      background: '#f8e6ff url("https://svgshare.com/i/12ad.svg") repeat',
      timer: 5000,
      timerProgressBar: true,
      willOpen: () => {
        setShowTitle(false);
        setShowNext(false);
      },
      didOpen: popup => {
        popup.querySelector('button.swal2-confirm').classList.add('swal2-animate-pop');
      },
      didClose: () => setShowTitle(true)
    }).then(() => setShowTitle(true));
  }, []);

  useEffect(() => {
    if (!showTitle) return;
    
    const handleScroll = () => {
      if (!scrollContainerRef.current) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const scrollContainer = scrollContainerRef.current;
      const containerTop = scrollContainer.getBoundingClientRect().top + scrollTop;
      const scrollStart = containerTop - windowHeight * 0.4;
      
      // Hide plane before reaching containers
      if (scrollTop < scrollStart) {
        setPlanePosition({ top: 0, left: '50%', visible: false, rotation: 0, index: -1 });
        setShowNext(false);
        return;
      }

      // Find the container closest to viewport center
      let activeIndex = -1;
      let minDistance = Infinity;
      const viewportCenter = windowHeight * 0.5;
      
      containerRefs.current.forEach((ref, index) => {
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        
        // Check if container is in viewport
        if (rect.top < windowHeight && rect.bottom > 0) {
          const containerCenter = rect.top + rect.height / 2;
          const distance = Math.abs(containerCenter - viewportCenter);
          
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        }
      });

      // If none considered active (e.g., scrolled past the last), pick the last
      if (activeIndex === -1) {
        activeIndex = LETTERS.length - 1;
      }

      // Update plane position to active container
      if (activeIndex >= 0) {
        const activeRef = containerRefs.current[activeIndex];
        if (activeRef) {
          const laneElement = activeRef.querySelector('.item-lane');
          if (laneElement) {
            const laneRect = laneElement.getBoundingClientRect();
            const markerElement = laneElement.querySelector('.plane-stop-marker');
            if (markerElement) {
              const markerRect = markerElement.getBoundingClientRect();
              // Position plane exactly at the center of the marker
              const planeTop = markerRect.top + markerRect.height / 2;
              const markerCenterX = markerRect.left + markerRect.width / 2;
              
              setPlanePosition(prev => {
                // Calculate rotation based on movement direction
                const prevLeft = prev.left === '50%' ? window.innerWidth / 2 : parseFloat(prev.left || window.innerWidth / 2);
                const distance = Math.abs(markerCenterX - prevLeft);
                let rotation = 0;
                
                if (distance > 20) {
                  if (markerCenterX > prevLeft + 15) rotation = 20; else if (markerCenterX < prevLeft - 15) rotation = -20; else rotation = prev.rotation ? prev.rotation * 0.7 : 0;
                } else {
                  rotation = 0;
                }
                
                return { 
                  top: Math.max(60, planeTop),
                  left: `${markerCenterX}px`,
                  visible: true, 
                  index: activeIndex,
                  rotation
                };
              });
            } else {
              // Fallback to lane center if marker not found
              const planeTop = laneRect.top + laneRect.height / 2;
              const containerRect = activeRef.getBoundingClientRect();
              const planeLeft = containerRect.left + containerRect.width / 2;
              
              setPlanePosition(prev => ({
                top: Math.max(60, planeTop),
                left: `${planeLeft}px`,
                visible: true, 
                index: activeIndex,
                rotation: 0
              }));
            }
          }
        }
      } else {
        // keep last known
        setPlanePosition(prev => prev.visible ? prev : { top: 0, left: '50%', visible: false, rotation: 0, index: -1 });
      }

      // toggle next button when last index
      setShowNext(activeIndex >= 7);
    };

    // Throttle scroll for better performance
    let ticking = false;
    const scrollHandler = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', scrollHandler, { passive: true });
    handleScroll(); // Initial call
    
    // Also trigger on resize
    window.addEventListener('resize', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('resize', handleScroll);
    };
  }, [showTitle]);

  useEffect(() => {
    document.body.classList.add('things-bg');
    return () => document.body.classList.remove('things-bg');
  }, []);

  return (
    <div className="things-bg-animated">
      {showTitle && (
        <div className="things-title animated-in">
          <img 
            src={thingsText} 
            alt="10 things I love about you" 
            style={{
              maxWidth: '90vw',
              width: 'auto',
              height: 'auto',
              display: 'block',
              margin: '0 auto'
            }}
          />
        </div>
      )}
      <FlyingPlane position={planePosition} />
      <div className="things-scroll-list" ref={scrollContainerRef}>
        {LETTERS.map((L, idx) => {
          // Pattern: kanan → tengah → kiri (repeat)
          // index % 3: 0 = kanan, 1 = tengah, 2 = kiri
          const position = idx % 3;
          const positionClass = position === 0 ? 'item-right' : position === 1 ? 'item-center' : 'item-left';
          return (
            <AppearOnScroll key={L} index={idx}>
              <div 
                className={`item-box ${positionClass} ${planePosition.index === idx && planePosition.visible ? 'plane-landed' : ''}`}
                ref={el => containerRefs.current[idx] = el}
              >
                <div className="item-lane">
                  <div className={`plane-stop-marker ${planePosition.index === idx && planePosition.visible ? 'active' : ''}`}></div>
                </div>
                <div className="item-note">
                  {/* HAPUS kode <span className="circle-letter"> ... </span> */}
                  <span className="item-desc">{DESC[idx]}</span>
                </div>
                {/* PIC DI BAWAH TEKS */}
                <div style={{textAlign:'center',marginTop:'12px'}}>
                  <img src={PICTURES[idx]} alt={`t${idx + 1}`} style={{width:"90%",maxWidth:"320px",borderRadius:"16px",boxShadow:'0 8px 28px #cfb7f876'}} />
                </div>
              </div>
            </AppearOnScroll>
          );
        })}
      </div>
      {showNext && (
        <div className="things-next-wrapper">
          <button className="things-next-button" onClick={() => navigate('/puzzle')}>
            Next→
          </button>
        </div>
      )}
    </div>
  );
}

function AppearOnScroll({ children, index }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.3, rootMargin: '0px 0px -50px 0px' }
    );
    
    obs.observe(element);
    return () => {
      if (element) obs.unobserve(element);
    };
  }, []);

  return (
    <div ref={ref} className={"appear-section" + (visible ? " show" : '')} style={{transitionDelay: (index*160)+'ms'}}>
      {children}
    </div>
  );
}

function FlyingPlane({ position }) {
  const [isVisible, setIsVisible] = React.useState(false);
  
  React.useEffect(() => {
    if (position.visible) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [position.visible]);
  
  if (!isVisible) return null;
  
  const rotation = position.rotation || 0;
  
  return (
    <div 
      className={`flying-plane ${position.visible ? 'plane-visible' : ''}`}
      style={{ 
        top: `${position.top}px`,
        left: position.left,
        transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
        transition: 'top 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), left 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
      }}
    >
      <div className="plane-icon">✈️</div>
      <div className="plane-trail" style={{
        transform: rotation > 0 ? 'translateY(-50%) translateX(-10px)' : rotation < 0 ? 'translateY(-50%) translateX(10px)' : 'translateY(-50%)'
      }}></div>
    </div>
  );
}
